import request from '@/utils/request.js'

// 首页-获取Banner图列表
export const getBannerList = function () {
  return request.get('/api/user/pub/banner.ashx')
}

// 首页-获取赛事列表
export const getActivityList = function () {
  return request.get('/api/user/pub/activity.ashx')
}

// 获取赛事详情
export const getActivityDetail = function (Id, Token) {
  return request.get('/api/user/pub/activity_detail.ashx', {
    params: {
      Id,
      Token
    }
  })
}

// 根据ScenceId获取游戏列表
export const getGamesByScence = function (ScenceId, Token) {
  return request.get('/api/user/pub/scence_games.ashx', {
    params: {
      ScenceId,
      Token
    }
  })
}

// 我的-主页面
export const getUserMain = function (Token) {
  return request.get('/api/user/main.ashx', {
    params: {
      Token
    }
  })
}

// 我的-个人信息
export const getUserProfile = function (Token) {
  return request.get('/api/user/profile.ashx', {
    params: {
      Token
    }
  })
}

// 我的-我的报名列表
export const getMyActivity = function (Token) {
  return request.get('/api/user/my_activity.ashx', {
    params: {
      Token
    }
  })
}

// 我的-我的报名详情
export const getMyActivityDetail = function (Token, Id) {
  return request.get('/api/user/my_activity_detail.ashx', {
    params: {
      Token,
      Id
    }
  })
}

// 取消报名
export const cancelMyActivity = function (Token, Id) {
  return request.get('/api/user/cancel_activity.ashx', {
    params: {
      Token,
      Id
    }
  })
}

// 获取地区
export const getArea = function () {
  return request.get('/api/user/pub/area.ashx')
}

// 获取短信验证码 Get带参数
export const getVerification = function (mobile) {
  return request.get('/api/user/send_code.ashx', {
    params: {
      Mobile: mobile
    }
  })
}

// 保存用户个人信息 Post，Json格式
export const userModify = function (data) {
  return request.post('/api/user/modify.ashx', data)
}

// 检验Token是否有效
export const getTokenStatus = function (Token) {
  return request.get('/api/user/check_token.ashx', {
    params: {
      Token
    }
  })
}

// 报名 Post，Json格式
export const userJoinActivity = function (data) {
  return request.post('/api/user/join.ashx', data)
}

// 微信授权登录
export const wxAuthorize = function (code) {
  return request.get('/api/user/wx_callback.ashx', {
    params: {
      code
    }
  })
}

// 微信自定义分享
export const wxSign = function (url) {
  return request.get('/api/user/wx_sign.ashx', {
    params: {
      url
    }
  })
}

// 微信签到验证
export const qdActivity = function (ActivityId,ScenceId, Token) {
  return request.get('/api/user/qd_activity.ashx', {
    params: {
      ActivityId,
      ScenceId,
      Token
    }
  })
}

// 微信签到
export const postQianDao = function (data) {
  return request.post('/api/user/wx_qiandao.ashx', data)
}

// 微信签到后展示报名二维码集合
export const getCodes = function (Token, Ids) {
  return request.get('/api/user/get_codes.ashx', {
    params: {
      Token,
      Ids
    }
  })
}

// 裁判打分 Post，Json格式
export const judgeSubmit = function (data) {
  return request.post('/api/judge/submit.ashx', data)
}

/************************************/
//榜单-首页
export const getRankIndex = function () {
  return request.get('/api/user/pub/rank_index.ashx')
}

// 榜单-详情
export const getRankDetail = function (ActivityId,ScenceId) {
  return request.get('/api/user/pub/rank_detail.ashx', {
    params: {
      ActivityId,
      ScenceId
    }
  })
}

// 榜单-选手列表
export const getRankList = function (ActivityId,ScenceId,GameId) {
  return request.get('/api/user/pub/rank_list.ashx', {
    params: {
      ActivityId,
      ScenceId,
      GameId
    }
  })
}